
import ChatPopup from "../chat/ChatPopup";
function Footer() {
  return (
    <footer className="mt-auto py-5 bg-dark">
      <ChatPopup sheetUrl="https://script.google.com/macros/s/AKfycbyvlWkYRXRct-GXwbOVSF3kox5TmPyHk-whcHJ2Kv4df60zuDDzRXNiaqk-tMVGVe4L2A/exec" />

      <div className="container d-flex justify-content-center">
        <span className="text-muted">Copyright &copy; AnPhat 2022</span>
      </div>
    </footer>
  );
}

export default Footer;
